import styled from "styled-components"

const AddBtn = () => {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <StyledPath
        d="M25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0ZM21.0083 10.91H28.9917V21.0083H39.09V28.9917H28.9917V39.09H21.0083V28.9917H10.91V21.0083H21.0083V10.91Z"
      />
    </svg>
  )
}

const StyledPath = styled.path`
  fill : ${(props)=>props.theme.theme==='light' ? 'var(--color-blue)' : 'var(--color-green)' };
`

export default AddBtn